import React, { useMemo } from 'react';
import { Empty } from 'antd';
import { useTranslation } from 'react-i18next';

import WmsNoUpdateTable, { WmsNoUpdateScope } from '../no-update-shared/WmsNoUpdateTable';
import { useWarehouseContext } from '../../../contexts/WarehouseContext';

/**
 * Warehouse 由左侧 WMS 仓库选择器决定；只看尾程断更（断在 whs / 断在 dsp）
 */
const WmsNoUpdateWarehousePage: React.FC = () => {
    const { t } = useTranslation();
    const { currentWarehouse } = useWarehouseContext();
    const effectiveWhsId = currentWarehouse?.id != null ? Number(currentWarehouse.id) : undefined;

    // scope 引用必须稳定，原因同 WmsNoUpdateHubPage
    const scope: WmsNoUpdateScope | null = useMemo(
        () => (effectiveWhsId == null ? null : { kind: 'whs', whsId: effectiveWhsId }),
        [effectiveWhsId],
    );

    if (scope == null) {
        return (
            <div className="bg-white rounded-lg shadow-sm px-3 pb-3 pt-3">
                <Empty description={t('wms.dashboard.noUpdate.empty.selectWarehouse')} />
            </div>
        );
    }

    return (
        <div className="bg-white rounded-lg shadow-sm px-3 pb-3 pt-0">
            <WmsNoUpdateTable scope={scope} category="LAST_MILE" />
        </div>
    );
};

export default WmsNoUpdateWarehousePage;
